/* Shopify cart transfer. Single-variant product map from supplied exports. */
(function(){
"use strict";
if(window.__shopYYCartSenderV1)return;
window.__shopYYCartSenderV1=true;

var busy=false;
function checkoutUrl(raw){try{var u=new URL(raw,location.href);return (u.origin===location.origin||u.hostname==='checkout.vinylsale.fr')&&/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout(?:\/|$)/i.test(u.pathname);}catch(e){return false;}}
async function transfer(event){
 event.preventDefault();event.stopImmediatePropagation();if(busy)return;busy=true;
 try{
  var root=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
  var response=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
  if(!response.ok)throw new Error('Impossible de lire le panier.');
  var cart=await response.json();
  if(!cart.items||!cart.items.length)throw new Error('Votre panier est vide.');
  var unsupported=[],grouped={};
  cart.items.forEach(function(item){
   var sku=String(item.sku||'').trim().replace(/^'+/,'');
   var matched=window.shopYYResolve({title:item.product_title,sku:sku,handle:item.handle});
   var id=matched.product_id;
   var custom=Object.keys(item.properties||{}).length>0;
   if(!id||custom||item.selling_plan_allocation){unsupported.push(item.product_title||item.title);return;}
   if(!Number.isSafeInteger(item.quantity)||item.quantity<1||item.quantity>999)throw new Error('Quantité invalide.');
   var key=matched.sku_code;
   if(!grouped[key])grouped[key]={product_id:id,sku_code:matched.sku_code,quantity:0,property:[]};
   grouped[key].quantity+=item.quantity;
   if(grouped[key].quantity>999)throw new Error('Quantité trop élevée.');
  });
  if(unsupported.length)throw new Error('Correspondance à vérifier pour : '+unsupported.join(', '));
  var items=Object.values(grouped);
  if(items.length>100)throw new Error('Le panier contient trop de produits.');
  // Reuse transfer ID for the unchanged basket, so returning and clicking again does not add it twice in the same receiving tab.
  var signature=JSON.stringify(items),old=null;
  try{old=JSON.parse(sessionStorage.getItem('shopYYLastTransfer')||'null');}catch(e){}
  var transferId=old&&old.signature===signature?old.id:crypto.randomUUID();
  sessionStorage.setItem('shopYYLastTransfer',JSON.stringify({id:transferId,signature:signature}));
  var target=new URL('https://checkout-yourorders.com/cart');
  var hash=new URLSearchParams();hash.set('transfer_id',transferId);hash.set('wc_cart',signature);target.hash=hash.toString();
  if(target.href.length>24000)throw new Error('Le panier est trop volumineux pour ce transfert.');
  location.assign(target.href);
 }catch(error){busy=false;alert(error.message||'Impossible de transférer le panier.');}
}
window.addEventListener('click',function(event){
 if(!(event.target instanceof Element))return;
 var el=event.target.closest('#checkout,button[name="checkout"],input[name="checkout"],a[href],button[formaction],input[formaction]');
 if(!el)return;
 if(el.id==='checkout'||el.name==='checkout'||(el.tagName==='A'&&checkoutUrl(el.getAttribute('href')))||(el.hasAttribute('formaction')&&checkoutUrl(el.getAttribute('formaction'))))transfer(event);
},true);
window.addEventListener('submit',function(event){
 var form=event.target;if(!(form instanceof HTMLFormElement))return;
 var b=event.submitter;
 var action=b&&b.hasAttribute('formaction')?b.formAction:form.action;
 if((b&&(b.name==='checkout'||b.id==='checkout'))||checkoutUrl(action))transfer(event);
},true);
window.addEventListener('pageshow',function(){busy=false;});
})();
